/**
 * Стан правої панелі «Сьогодні»: кнопка-перемикач живе в панелі екрана, панель — в оболонці.
 * `source` — звідки дані (API модуля задач після входу); `null` — панелі немає взагалі
 * (модуль задач вимкнено або людина не читає задач). `here` — стартовий екран, де панель стоїть.
 */
import { createContext, useContext } from 'react';
import type { TodaySource } from '../features/today/source.ts';

export interface TodayPanelState {
  open: boolean;
  setOpen: (open: boolean) => void;
  source: TodaySource | null;
  here: boolean;
}

export const TodayPanelContext = createContext<TodayPanelState>({
  open: false,
  setOpen: () => {},
  source: null,
  here: false,
});

export const useTodayPanel = () => useContext(TodayPanelContext);
